var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHdfc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 200,
    viewBox: "0 0 193 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1861_57110)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1861_57110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.7793H1157.07V196.219H0V3.7793Z",
    fill: "#004C8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.7793H192.83V196.219H0V3.7793Z",
    fill: "#ED232A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.748 37.459H159.102V162.559H33.748V37.459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7739 3.7793H106.052V196.219H86.7739V3.7793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 90.4023H192.83V109.641H0V90.4023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5 71.1406H125.349V128.877H67.5V71.1406Z",
    fill: "#004C8F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1861_57110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 200,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1861_57110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdfc);
export default __webpack_public_path__ + "static/media/hdfc.7aa68b2622f260ff8903d92eddc7dbff.svg";
export { ForwardRef as ReactComponent };